/**
 * Represents the type of the email
 */
export const enum EmailType {
  RESEND_VERIFY_SIGNUP = 'resendVerifySignup',
  VERIFY_SIGNUP = 'verifySignup',
  VERIFY_SIGNUP_SET_PASSWORD = 'verifySignupSetPassword',
  SEND_RESET_PASSWORD = 'sendResetPassword',
  REST_PASSWORD = 'resetPassword',
  CHANGE_PASSWORD = 'changePassword',
  CHANGE_IDENTITY = 'changeIdentity',
  PAYMENT_SUCCESS = 'paymentSuccess',
  VERIFY_TWO_FACTOR_AUTHENTICATION = 'verifyTwoFactorAuthentication',
}
